'use strict';

module.exports = {
  template: require('./cn-invite-import-instructions.html'),
  controller: require('./cn-invite-import-instructions.controller'),
  controllerAs: 'vm',

  bindings: {
    toggle: '<',
    descriptionText: '@',
    withComment: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-invite-import-instructions/index.js
 ** module id = 80
 ** module chunks = 0
 **/